module.exports = __webpack_public_path__ + "img/sdc-logo.171b2dd1.webp";